import type { ComponentPropsWithoutRef } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useBuilderStore } from "../Hooks/useBuilderStore";
import { RightSidebar } from "../RightSidebar/RightSidebar";
import { ToggleCollapseButton } from "./ToggleCollapseButton";

export const CollapsibleRightSidebar = ({
  children,
  ...rest
}: ComponentPropsWithoutRef<"aside">) => {
  const isRightSidebarOpen = useBuilderStore(state => state.isRightSidebarOpen);

  return (
    <div
      className={classNames(
        "absolute right-0 size-full max-w-72 translate-x-72 transition-transform",
        {
          "translate-x-0": isRightSidebarOpen,
        },
      )}
    >
      <div
        className={classNames("absolute -left-7 top-3 transition-all", {
          "hover:-left-10": !isRightSidebarOpen,
        })}
      >
        <ToggleCollapseButton />
      </div>
      <RightSidebar {...rest}>{children}</RightSidebar>
    </div>
  );
};
